module.exports = "/assets/4b7929fbe878d214a8f9929002ed7c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3X.png
// module id = 2155
// module chunks = 0